import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from '../../../Utils';
import { connect, actions } from '../../../Store';
import BaseList from '../BaseList';
import AlertPopup from '../../../Components/AlertPopup';
import Toning from '../../Toning';
import API2 from '../../../API2';

const ToningWrapper = styled.div`
  padding-bottom: ${rem(400)};
`;

class Tinting extends BaseList {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      title: __('Tónovanie'),
      notFoundMessage: __('Nepodarilo sa načítať produkty pre tónovanie'),
      isProduct: true,
      loading: false,

      showFilter: false,
      showSearch: false,
      showPager: false,
      items: [''],
    };

    actions.setActiveMenuItem('72');
  }

  async addToCard(data, forced = false) {
    const { activeCart } = this.props;
    const { product, colorCode, toningSystemId, colorCardId, quantity } = data;

    this.setState({
      addLoading: true,
    });

    const myCarts = await API2.getCartsAction();
    const selectedCart = myCarts.carts.find(c => c._id === activeCart);

    if (product) {
      try {
        let cartToLoad = selectedCart;

        if (!selectedCart) {
          cartToLoad = await API2.createCartAction({
            body: { title: 'cart1' },
          });
        }

        const dataToSend = {
          quantity,
          product_id: product._id,
          is_wh010_sale: product.is_wh010_sale,
          is_sale: product.is_sale,
        };

        if (
          colorCode &&
          toningSystemId &&
          colorCardId &&
          (!product.finished_shade || !product.finished_shade.length)
        ) {
          if (colorCode) {
            dataToSend.color_code = colorCode;
            dataToSend.toningSystemId = toningSystemId;
            dataToSend.colorCardId = colorCardId;
          }
          dataToSend.coefficient =
            product.variantParams &&
            product.variantParams.find(vp => vp.name === 'Koeficient tónovania')
              ? Number(
                  product.variantParams.find(
                    vp => vp.name === 'Koeficient tónovania',
                  ).value,
                ) || 1
              : product.coefficient || 1;
        }
        const cartResult = await API2.postCartItemAction(cartToLoad._id, {
          body: dataToSend,
          addToExistingItem: forced,
        });
        actions.updateCarts(cartResult.cart);
      } catch (e) {
        if (e.response.status === 409) {
          this.addToCard(data, true);
        }
      }
    }
  }

  async addProductsToCart(data) {
    this.setState({
      addLoading: true,
    });
    await this.addToCard({
      product: Object.assign(data.product, {
        toningPrice: data.product.price,
      }),
      colorCode: data.color.color_code,
      toningSystemId: data.toningSystem,
      colorCardId: data.colorCardId,
      quantity: data.count,
    });

    if (data.complementarProduct && data.complementarQuantity > 0) {
      await this.addToCard({
        product: data.complementarProduct,
        quantity: data.complementarQuantity,
      });
    }

    this.setState({
      addLoading: false,
      showSuccess: true,
    });
  }

  renderItemsList() {
    return (
      <ToningWrapper>
        <Toning
          confirmButtonTitle={__('Pridať do košíka')}
          showButton
          applyMargin
          addLoading={this.state.addLoading}
          onConfirm={data => this.addProductsToCart(data)}
          location={this.props.location}
          history={this.props.history}
        />
      </ToningWrapper>
    );
  }

  render() {
    const { showSuccess } = this.state;
    return (
      <React.Fragment>
        <AlertPopup
          alignUnderHeader
          display={showSuccess}
          text={__('Produkt bol pridaný do objednávky')}
          success
          onClose={() =>
            this.setState({
              showSuccess: false,
            })
          }
          onSubmit={() =>
            this.setState({
              showSuccess: false,
            })
          }
        />
        {super.render()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Tinting);



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/Tinting/index.jsx